import { useEffect, useMemo } from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFiltersRegistry } from "../../../../../../context/FiltersProvider";
import { RootCausePayload, RootCauseWidgetWaterfallDTO } from "../../../../../../datasources/api-client/data-contracts";
import { ApiRoutes } from "../../../../../../datasources/networking/apiRoutes";
import { useReadResource } from "../../../../../../hooks/useResource";
import { AbsoluteBreakDown } from "./AbsoluteBreakdown";
import { getRootCauseWaterfallLabels, mapRootCauseWaterfallToPieChart } from "./data";
import { Waterfall } from "./Waterfall";

type RootCauseAnalysisProps = {
	onWarningsChange?: (warnings?: string[]) => void;
};

export const RootCauseAnalysis = ({ onWarningsChange }: RootCauseAnalysisProps) => {
	const { rootCauseState } = useFiltersRegistry();
	const { t } = useTranslation("whatif.rootcause");

	const { data, isLoading } = useReadResource<RootCausePayload, RootCauseWidgetWaterfallDTO>(
		{
			route: ApiRoutes.RootCauseWidjetWaterfall,
		},
		{
			readMethod: "post",
		},
		{ ...rootCauseState.payload }
	);

	useEffect(() => {
		onWarningsChange?.(data?.warnings ?? []);
	}, [data?.warnings]);

	const waterfallLabels = useMemo(() => getRootCauseWaterfallLabels(t), [t]);
	const pieChartData = useMemo(
		() => mapRootCauseWaterfallToPieChart(data, waterfallLabels),
		[data, waterfallLabels]
	);

	return (
		<Stack gap={2}>
			<Waterfall title="Waterfall" isLoading={isLoading} data={data} labels={waterfallLabels} />
			<AbsoluteBreakDown title="Absolute breakdown" pieChartData={pieChartData} isLoading={isLoading} />
		</Stack>
	);
};
